/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */
import type {
  ClosePosition,
  ConfirmOrder,
  GetTradingOrders200,
  GetTradingOrders401,
  GetTradingOrdersOrderId200,
  GetTradingOrdersOrderId401,
  GetTradingOrdersOrderId404,
  GetTradingOrdersParams,
  GetTradingOrdersSimulationFuture200,
  GetTradingOrdersSimulationFuture400,
  GetTradingOrdersSimulationFuture401,
  GetTradingOrdersSimulationFutureParams,
  GetTradingOrdersSimulationLimit200,
  GetTradingOrdersSimulationLimit400,
  GetTradingOrdersSimulationLimit401,
  GetTradingOrdersSimulationLimitParams,
  GetTradingOrdersSimulationMarket200,
  GetTradingOrdersSimulationMarket400,
  GetTradingOrdersSimulationMarket401,
  GetTradingOrdersSimulationMarketParams,
  GetTradingOrdersSimulationSwap200,
  GetTradingOrdersSimulationSwap400,
  GetTradingOrdersSimulationSwap401,
  GetTradingOrdersSimulationSwapParams,
  GetTradingSwapCoins200,
  GetTradingSwapCoins401,
  GetTradingSwapCoins404,
  GetTradingSwapCoinsParams,
  PostTradingOrders201,
  PostTradingOrders400,
  PostTradingOrders401,
  PostTradingOrdersOrderIdCancel200,
  PostTradingOrdersOrderIdCancel401,
  PostTradingOrdersOrderIdCancel404,
  PostTradingOrdersOrderIdCancel409,
  PostTradingOrdersOrderIdClose200,
  PostTradingOrdersOrderIdClose401,
  PostTradingOrdersOrderIdClose404,
  PostTradingOrdersOrderIdClose409
} from '../../models';

import { customFetch } from '../../mutator/customFetch';

/**
 * Lista as ordens do usuário autenticado com filtros opcionais por category, product, orderStatus e symbol. Suporta paginação por cursor.
 * @summary List orders
 */
export type getTradingOrdersResponse200 = {
  data: GetTradingOrders200
  status: 200
}

export type getTradingOrdersResponse401 = {
  data: GetTradingOrders401
  status: 401
}

export type getTradingOrdersResponseSuccess = (getTradingOrdersResponse200) & {
  headers: Headers;
};
export type getTradingOrdersResponseError = (getTradingOrdersResponse401) & {
  headers: Headers;
};

export type getTradingOrdersResponse = (getTradingOrdersResponseSuccess | getTradingOrdersResponseError)

export const getGetTradingOrdersUrl = (params?: GetTradingOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedopay.dev/trading/orders?${stringifiedParams}` : `https://api.wedopay.dev/trading/orders`
}

export const getTradingOrders = async (params?: GetTradingOrdersParams, options?: RequestInit): Promise<getTradingOrdersResponse> => {
  
  return customFetch<getTradingOrdersResponse>(getGetTradingOrdersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Confirma e cria a ordem usando o `quoteId` retornado pela simulação. O quoteId expira em 60 segundos (13 s para SWAP). 
 * @summary Confirm and create order
 */
export type postTradingOrdersResponse201 = {
  data: PostTradingOrders201
  status: 201
}

export type postTradingOrdersResponse400 = {
  data: PostTradingOrders400
  status: 400
}

export type postTradingOrdersResponse401 = {
  data: PostTradingOrders401
  status: 401
}

export type postTradingOrdersResponseSuccess = (postTradingOrdersResponse201) & {
  headers: Headers;
};
export type postTradingOrdersResponseError = (postTradingOrdersResponse400 | postTradingOrdersResponse401) & {
  headers: Headers;
};

export type postTradingOrdersResponse = (postTradingOrdersResponseSuccess | postTradingOrdersResponseError)

export const getPostTradingOrdersUrl = () => {


  

  return `https://api.wedopay.dev/trading/orders`
}

export const postTradingOrders = async (confirmOrder: ConfirmOrder, options?: RequestInit): Promise<postTradingOrdersResponse> => {
  
  return customFetch<postTradingOrdersResponse>(getPostTradingOrdersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      confirmOrder,)
  }
);}
  

/**
 * Retorna os detalhes completos de uma ordem do usuário autenticado, incluindo a lista de execuções (fills). O `orderId` aqui é o `internalId` (UUID interno da ordem — campo `Order.internalId` / `WalletHistoryDetail.internalId`).
 * @summary Get order detail
 */
export type getTradingOrdersOrderIdResponse200 = {
  data: GetTradingOrdersOrderId200
  status: 200
}

export type getTradingOrdersOrderIdResponse401 = {
  data: GetTradingOrdersOrderId401
  status: 401
}

export type getTradingOrdersOrderIdResponse404 = {
  data: GetTradingOrdersOrderId404
  status: 404
}

export type getTradingOrdersOrderIdResponseSuccess = (getTradingOrdersOrderIdResponse200) & {
  headers: Headers;
};
export type getTradingOrdersOrderIdResponseError = (getTradingOrdersOrderIdResponse401 | getTradingOrdersOrderIdResponse404) & {
  headers: Headers;
};

export type getTradingOrdersOrderIdResponse = (getTradingOrdersOrderIdResponseSuccess | getTradingOrdersOrderIdResponseError)

export const getGetTradingOrdersOrderIdUrl = (orderId: string,) => {


  

  return `https://api.wedopay.dev/trading/orders/${orderId}`
}

export const getTradingOrdersOrderId = async (orderId: string, options?: RequestInit): Promise<getTradingOrdersOrderIdResponse> => {
  
  return customFetch<getTradingOrdersOrderIdResponse>(getGetTradingOrdersOrderIdUrl(orderId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Simula uma ordem a mercado (execução imediata no melhor preço disponível). Informe `inputAmount` (quanto quer gastar) OU `outputAmount` (quanto quer receber). Retorna um `quoteId` válido por 30 segundos para confirmar via `POST /trading/orders`.
 * @summary Simulation market order
 */
export type getTradingOrdersSimulationMarketResponse200 = {
  data: GetTradingOrdersSimulationMarket200
  status: 200
}

export type getTradingOrdersSimulationMarketResponse400 = {
  data: GetTradingOrdersSimulationMarket400
  status: 400
}

export type getTradingOrdersSimulationMarketResponse401 = {
  data: GetTradingOrdersSimulationMarket401
  status: 401
}

export type getTradingOrdersSimulationMarketResponseSuccess = (getTradingOrdersSimulationMarketResponse200) & {
  headers: Headers;
};
export type getTradingOrdersSimulationMarketResponseError = (getTradingOrdersSimulationMarketResponse400 | getTradingOrdersSimulationMarketResponse401) & {
  headers: Headers;
};

export type getTradingOrdersSimulationMarketResponse = (getTradingOrdersSimulationMarketResponseSuccess | getTradingOrdersSimulationMarketResponseError)

export const getGetTradingOrdersSimulationMarketUrl = (params: GetTradingOrdersSimulationMarketParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedopay.dev/trading/orders/simulation/market?${stringifiedParams}` : `https://api.wedopay.dev/trading/orders/simulation/market`
}

export const getTradingOrdersSimulationMarket = async (params: GetTradingOrdersSimulationMarketParams, options?: RequestInit): Promise<getTradingOrdersSimulationMarketResponse> => {
  
  return customFetch<getTradingOrdersSimulationMarketResponse>(getGetTradingOrdersSimulationMarketUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Simula uma ordem spot do tipo LIMIT. A ordem será executada apenas quando o preço de mercado atingir o valor definido. Retorna um `quoteId` válido por 30 segundos para confirmar via `POST /trading/orders`.
 * @summary Simulation limit order
 */
export type getTradingOrdersSimulationLimitResponse200 = {
  data: GetTradingOrdersSimulationLimit200
  status: 200
}

export type getTradingOrdersSimulationLimitResponse400 = {
  data: GetTradingOrdersSimulationLimit400
  status: 400
}

export type getTradingOrdersSimulationLimitResponse401 = {
  data: GetTradingOrdersSimulationLimit401
  status: 401
}

export type getTradingOrdersSimulationLimitResponseSuccess = (getTradingOrdersSimulationLimitResponse200) & {
  headers: Headers;
};
export type getTradingOrdersSimulationLimitResponseError = (getTradingOrdersSimulationLimitResponse400 | getTradingOrdersSimulationLimitResponse401) & {
  headers: Headers;
};

export type getTradingOrdersSimulationLimitResponse = (getTradingOrdersSimulationLimitResponseSuccess | getTradingOrdersSimulationLimitResponseError)

export const getGetTradingOrdersSimulationLimitUrl = (params: GetTradingOrdersSimulationLimitParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedopay.dev/trading/orders/simulation/limit?${stringifiedParams}` : `https://api.wedopay.dev/trading/orders/simulation/limit`
}

export const getTradingOrdersSimulationLimit = async (params: GetTradingOrdersSimulationLimitParams, options?: RequestInit): Promise<getTradingOrdersSimulationLimitResponse> => {
  
  return customFetch<getTradingOrdersSimulationLimitResponse>(getGetTradingOrdersSimulationLimitUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Simula a conversão direta entre duas criptomoedas (ex: BTC → ETH). Sem necessidade de informar side — a conversão é sempre inputCurrency → outputCurrency. Informe `inputAmount` OU `outputAmount`. Retorna um `quoteId` válido por 30 segundos para confirmar via `POST /trading/orders`.
 * @summary Simulation swap (crypto-to-crypto)
 */
export type getTradingOrdersSimulationSwapResponse200 = {
  data: GetTradingOrdersSimulationSwap200
  status: 200
}

export type getTradingOrdersSimulationSwapResponse400 = {
  data: GetTradingOrdersSimulationSwap400
  status: 400
}

export type getTradingOrdersSimulationSwapResponse401 = {
  data: GetTradingOrdersSimulationSwap401
  status: 401
}

export type getTradingOrdersSimulationSwapResponseSuccess = (getTradingOrdersSimulationSwapResponse200) & {
  headers: Headers;
};
export type getTradingOrdersSimulationSwapResponseError = (getTradingOrdersSimulationSwapResponse400 | getTradingOrdersSimulationSwapResponse401) & {
  headers: Headers;
};

export type getTradingOrdersSimulationSwapResponse = (getTradingOrdersSimulationSwapResponseSuccess | getTradingOrdersSimulationSwapResponseError)

export const getGetTradingOrdersSimulationSwapUrl = (params: GetTradingOrdersSimulationSwapParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedopay.dev/trading/orders/simulation/swap?${stringifiedParams}` : `https://api.wedopay.dev/trading/orders/simulation/swap`
}

export const getTradingOrdersSimulationSwap = async (params: GetTradingOrdersSimulationSwapParams, options?: RequestInit): Promise<getTradingOrdersSimulationSwapResponse> => {
  
  return customFetch<getTradingOrdersSimulationSwapResponse>(getGetTradingOrdersSimulationSwapUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Simula uma ordem de futuros (perpetual). Se `price` for informado, simula ordem limit; caso contrário, simula a mercado. Informe `inputAmount` OU `outputAmount`. Retorna um `quoteId` válido por 30 segundos para confirmar via `POST /trading/orders`.
 * @summary Simulation futures order
 */
export type getTradingOrdersSimulationFutureResponse200 = {
  data: GetTradingOrdersSimulationFuture200
  status: 200
}

export type getTradingOrdersSimulationFutureResponse400 = {
  data: GetTradingOrdersSimulationFuture400
  status: 400
}

export type getTradingOrdersSimulationFutureResponse401 = {
  data: GetTradingOrdersSimulationFuture401
  status: 401
}

export type getTradingOrdersSimulationFutureResponseSuccess = (getTradingOrdersSimulationFutureResponse200) & {
  headers: Headers;
};
export type getTradingOrdersSimulationFutureResponseError = (getTradingOrdersSimulationFutureResponse400 | getTradingOrdersSimulationFutureResponse401) & {
  headers: Headers;
};

export type getTradingOrdersSimulationFutureResponse = (getTradingOrdersSimulationFutureResponseSuccess | getTradingOrdersSimulationFutureResponseError)

export const getGetTradingOrdersSimulationFutureUrl = (params: GetTradingOrdersSimulationFutureParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedopay.dev/trading/orders/simulation/future?${stringifiedParams}` : `https://api.wedopay.dev/trading/orders/simulation/future`
}

export const getTradingOrdersSimulationFuture = async (params: GetTradingOrdersSimulationFutureParams, options?: RequestInit): Promise<getTradingOrdersSimulationFutureResponse> => {
  
  return customFetch<getTradingOrdersSimulationFutureResponse>(getGetTradingOrdersSimulationFutureUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Cancela uma ordem aberta do usuário autenticado. O `orderId` aqui é o `internalId` exposto no wallet history (`WalletHistoryDetail.internalId` — o UUID interno da ordem). Apenas ordens ainda abertas podem ser canceladas: no wallet history isso corresponde a `status` `CREATED` ou `PROCESSING` (mapeados de NEW/PARTIALLY_FILLED). A ordem também precisa estar aberta na Bybit.
 * @summary Cancel order
 */
export type postTradingOrdersOrderIdCancelResponse200 = {
  data: PostTradingOrdersOrderIdCancel200
  status: 200
}

export type postTradingOrdersOrderIdCancelResponse401 = {
  data: PostTradingOrdersOrderIdCancel401
  status: 401
}

export type postTradingOrdersOrderIdCancelResponse404 = {
  data: PostTradingOrdersOrderIdCancel404
  status: 404
}

export type postTradingOrdersOrderIdCancelResponse409 = {
  data: PostTradingOrdersOrderIdCancel409
  status: 409
}

export type postTradingOrdersOrderIdCancelResponseSuccess = (postTradingOrdersOrderIdCancelResponse200) & {
  headers: Headers;
};
export type postTradingOrdersOrderIdCancelResponseError = (postTradingOrdersOrderIdCancelResponse401 | postTradingOrdersOrderIdCancelResponse404 | postTradingOrdersOrderIdCancelResponse409) & {
  headers: Headers;
};

export type postTradingOrdersOrderIdCancelResponse = (postTradingOrdersOrderIdCancelResponseSuccess | postTradingOrdersOrderIdCancelResponseError)

export const getPostTradingOrdersOrderIdCancelUrl = (orderId: string,) => {


  

  return `https://api.wedopay.dev/trading/orders/${orderId}/cancel`
}

export const postTradingOrdersOrderIdCancel = async (orderId: string, options?: RequestInit): Promise<postTradingOrdersOrderIdCancelResponse> => {
  
  return customFetch<postTradingOrdersOrderIdCancelResponse>(getPostTradingOrdersOrderIdCancelUrl(orderId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Fecha (parcial ou totalmente) uma posição de futuros lineares enviando uma ordem oposta reduceOnly a mercado. O `orderId` aqui é o `internalId` da ordem de abertura (`WalletHistoryDetail.internalId` — o UUID interno), mesmo padrão do cancel. Informe `qty` para fechamento parcial; omita para fechar todo o restante. Apenas posições FUTURE preenchidas e ainda abertas podem ser fechadas (use o cancel para ordens não preenchidas).
 * @summary Close linear position
 */
export type postTradingOrdersOrderIdCloseResponse200 = {
  data: PostTradingOrdersOrderIdClose200
  status: 200
}

export type postTradingOrdersOrderIdCloseResponse401 = {
  data: PostTradingOrdersOrderIdClose401
  status: 401
}

export type postTradingOrdersOrderIdCloseResponse404 = {
  data: PostTradingOrdersOrderIdClose404
  status: 404
}

export type postTradingOrdersOrderIdCloseResponse409 = {
  data: PostTradingOrdersOrderIdClose409
  status: 409
}

export type postTradingOrdersOrderIdCloseResponseSuccess = (postTradingOrdersOrderIdCloseResponse200) & {
  headers: Headers;
};
export type postTradingOrdersOrderIdCloseResponseError = (postTradingOrdersOrderIdCloseResponse401 | postTradingOrdersOrderIdCloseResponse404 | postTradingOrdersOrderIdCloseResponse409) & {
  headers: Headers;
};

export type postTradingOrdersOrderIdCloseResponse = (postTradingOrdersOrderIdCloseResponseSuccess | postTradingOrdersOrderIdCloseResponseError)

export const getPostTradingOrdersOrderIdCloseUrl = (orderId: string,) => {


  

  return `https://api.wedopay.dev/trading/orders/${orderId}/close`
}

export const postTradingOrdersOrderIdClose = async (orderId: string,
    closePosition: ClosePosition, options?: RequestInit): Promise<postTradingOrdersOrderIdCloseResponse> => {
  
  return customFetch<postTradingOrdersOrderIdCloseResponse>(getPostTradingOrdersOrderIdCloseUrl(orderId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      closePosition,)
  }
);}
  

/**
 * Retorna a lista de moedas elegíveis para swap dado uma moeda âncora (`coin`) e um lado (`side`). A fonte é o endpoint `/v5/asset/exchange/query-coin-list` da Bybit, filtrada pelo catálogo local (`COIN_CATALOG`).
 * @summary Listar moedas disponíveis para swap
 */
export type getTradingSwapCoinsResponse200 = {
  data: GetTradingSwapCoins200
  status: 200
}

export type getTradingSwapCoinsResponse401 = {
  data: GetTradingSwapCoins401
  status: 401
}

export type getTradingSwapCoinsResponse404 = {
  data: GetTradingSwapCoins404
  status: 404
}

export type getTradingSwapCoinsResponseSuccess = (getTradingSwapCoinsResponse200) & {
  headers: Headers;
};
export type getTradingSwapCoinsResponseError = (getTradingSwapCoinsResponse401 | getTradingSwapCoinsResponse404) & {
  headers: Headers;
};

export type getTradingSwapCoinsResponse = (getTradingSwapCoinsResponseSuccess | getTradingSwapCoinsResponseError)

export const getGetTradingSwapCoinsUrl = (params: GetTradingSwapCoinsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedopay.dev/trading/swap/coins?${stringifiedParams}` : `https://api.wedopay.dev/trading/swap/coins`
}

export const getTradingSwapCoins = async (params: GetTradingSwapCoinsParams, options?: RequestInit): Promise<getTradingSwapCoinsResponse> => {
  
  return customFetch<getTradingSwapCoinsResponse>(getGetTradingSwapCoinsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

